module.exports = __webpack_public_path__ + "static/logo-234525546170f0068466c9e25b14a00c.svg";